var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quote-builder-sidebar box" }, [
    _c("nav", { staticClass: "main-nav" }, [
      _c("ul", [
        _c(
          "li",
          {
            class: {
              active: _vm.selectedMenu === _vm.MENU_MODES.MANUAL,
              disabled: !_vm.isQuoteEditable,
            },
            on: {
              click: function ($event) {
                _vm.isQuoteEditable &&
                  _vm.$emit("update:selectedMenu", _vm.MENU_MODES.MANUAL)
              },
            },
          },
          [
            _c("span", { staticClass: "mso mso-24px mr-2" }, [_vm._v("docs")]),
            _c("span", [_vm._v("Manual Quote")]),
          ]
        ),
        _c(
          "li",
          {
            class: {
              active: _vm.selectedMenu === _vm.MENU_MODES.TEMPLATES,
              disabled: !_vm.isQuoteEditable,
            },
            on: {
              click: function ($event) {
                _vm.isQuoteEditable &&
                  _vm.$emit("update:selectedMenu", _vm.MENU_MODES.TEMPLATES)
              },
            },
          },
          [
            _c("span", { staticClass: "mso mso-24px mr-2" }, [
              _vm._v("file_copy"),
            ]),
            _c("span", [_vm._v("Templates")]),
          ]
        ),
        _c(
          "li",
          {
            class: {
              active: _vm.selectedMenu === _vm.MENU_MODES.VEHICLE,
              disabled: !_vm.isQuoteEditable,
            },
            on: {
              click: function ($event) {
                _vm.isQuoteEditable &&
                  _vm.$emit("update:selectedMenu", _vm.MENU_MODES.VEHICLE)
              },
            },
          },
          [
            _c("span", { staticClass: "mso mso-24px mr-2" }, [
              _vm._v("no_crash"),
            ]),
            _c("span", [_vm._v("Vehicle Sections")]),
          ]
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedMenu === _vm.MENU_MODES.VEHICLE,
              expression: "selectedMenu === MENU_MODES.VEHICLE",
            },
          ],
          staticClass: "vehicle-sections",
        },
        [
          _c("hr", { staticClass: "divider my-2" }),
          _vm.isShowVehicleSectionContent
            ? _c(
                "div",
                {
                  staticClass:
                    "is-flex is-justify-content-space-between is-align-items-center mb-4",
                },
                [
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Sections"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "is-flex", staticStyle: { gap: "0.25rem" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "button is-small",
                          staticStyle: {
                            padding: "0.25em 0.25em",
                            "min-width": "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("modify")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "mso mso-24px" }, [
                            _vm._v("car_gear"),
                          ]),
                          _c("span", [_vm._v("Butterfly")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-small",
                          class: {
                            tooltip: _vm.innerSelectedSubSections.length,
                          },
                          staticStyle: { padding: "0.25em", "min-width": "0" },
                          attrs: {
                            "data-tooltip": "Reset",
                            disabled: !_vm.innerSelectedSubSections.length,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("reset")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "mso mso-24px" }, [
                            _vm._v("refresh"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowVehicleSectionContent,
                  expression: "isShowVehicleSectionContent",
                },
              ],
              staticClass: "vehicle-group-section",
            },
            [
              _c(
                "div",
                _vm._l(_vm.computedAreasWithParts, function (area) {
                  return _c(
                    "div",
                    { key: area.name, staticClass: "area-group" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            "area-header",
                            {
                              "is-area-selected":
                                _vm.innerSelectedArea === area.name,
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "area-content",
                              on: {
                                click: function ($event) {
                                  return _vm.filterByArea(area)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "area-name" }, [
                                _c("span", { staticClass: "area-name-text" }, [
                                  _vm._v(_vm._s(area.name)),
                                ]),
                              ]),
                              _c("div", { staticClass: "area-info" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.innerSelectedArea === area.name,
                                        expression:
                                          "innerSelectedArea === area.name",
                                      },
                                    ],
                                    staticClass: "mso is-size-6 is-white",
                                  },
                                  [_vm._v("keyboard_arrow_right")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "parts-list" },
                        _vm._l(area.parts, function (part) {
                          return _c(
                            "div",
                            {
                              key: part.partId,
                              class: [
                                "part-item",
                                { "is-selected": part.isFilter },
                              ],
                            },
                            [
                              _c("div", { staticClass: "part-remove" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "mso mso-16px remove-icon",
                                    attrs: { title: "Remove part" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removePartSelection(part)
                                      },
                                    },
                                  },
                                  [_vm._v("close")]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "part-content",
                                  on: {
                                    click: function ($event) {
                                      return _vm.togglePartSelection(part, area)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "part-name" }, [
                                    _vm._v(_vm._s(part.partName)),
                                  ]),
                                  _c("div", { staticClass: "part-info" }, [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: part.isFilter,
                                            expression: "part.isFilter",
                                          },
                                        ],
                                        staticClass: "mso is-size-6",
                                      },
                                      [_vm._v("keyboard_arrow_right")]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "job-value-section" }, [
        _c("hr", { staticClass: "divider" }),
        _c("div", { staticClass: "has-text-centered small-menu-text" }, [
          _vm._v("Total Job Value"),
        ]),
        _c(
          "table",
          {
            staticClass:
              "table is-striped is-extra-narrow is-fullwidth small-menu-text",
          },
          [
            _c(
              "tbody",
              { staticClass: "no-border" },
              _vm._l(_vm.itemTypes, function (itemType) {
                return _c("tr", { key: itemType.itemCategoryType }, [
                  _c("td", [_vm._v(_vm._s(itemType.displayName))]),
                  _c("td", { staticClass: "has-text-centered" }, [
                    _vm._v(
                      _vm._s(
                        _vm.mainSuppQuotePercentages[
                          itemType.itemCategoryType
                        ].toFixed(0)
                      )
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.7em",
                          "vertical-align": "super",
                        },
                      },
                      [_vm._v("%")]
                    ),
                  ]),
                  _c("td", { staticClass: "has-text-right" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.mainSuppQuoteTotals[itemType.itemCategoryType],
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ])
              }),
              0
            ),
            _c("tfoot", { staticClass: "no-border" }, [
              _c("tr", [
                _vm._m(0),
                _c("td", { staticClass: "has-text-right has-text-success" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatCurrency(
                        _vm.totalExGst,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]),
              ]),
              _c("tr", [
                _vm._m(1),
                _c("td", { staticClass: "has-text-right has-text-success" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$filters.formatCurrency(
                        _vm.totalIncGst,
                        _vm.$userInfo.locale
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "2" } }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "2" } }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }